export default __webpack_public_path__ + "static/media/Nick-Peri-Pattie-testimonial.9409a995.jpg";